<template>
	<!-- Vue Material Input -->
	<!-- https://vuematerial.io/components/input -->

	<md-field
		:class="{
			'md-has-value': fixedLabel,
			'md-invalid': errorMessage
		}"
		:md-clearable="clearable"
	>
		<md-icon v-if="icon" :class="icon"/>
		<label>{{ label }}</label>
		<md-input
			:autocomplete="autocomplete"
			:autofocus="autofocus"
			:disabled="disabled"
			:readonly="readonly"
			:required="required"
			:type="type"
			:value="value"
			@input="$emit('input', trim && type !== 'password' && typeof $event === 'string' ? $event.trim() : $event)"
			@change="$emit('change', $event)"
			@keyup.enter="$emit('enter')"
			@keydown="$emit('keydown', $event)"
		/>
		<md-icon v-if="inlineIcon" :class="inlineIcon"/>
		<span class="ui-icon--inline">
			<slot name="inlineIcon"/>
		</span>
		<transition name="fade">
			<span v-if="flashHintText" class="md-helper-text">{{ flashHintText }}</span>
		</transition>
		<span v-if="!flashHintText && hint" class="md-helper-text">{{ hint }}</span>
		<span v-if="errorMessage" class="md-error">{{ errorMessage }}</span>
	</md-field>
</template>

<script>
import UiInputValidator from "lib/components/ui/InputValidator";
import UiValidator from "lib/components/ui/Validator";

export default {
	name: "Input",
	mixins: [UiInputValidator, UiValidator],
	props: {
		autocomplete: {
			type: String,
			default: "on",
			required: false
		},
		autofocus: {
			type: Boolean,
			default: false,
			required: false
		},
		clearable: {
			type: Boolean,
			default: false,
			required: false
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		fixedLabel: {
			type: Boolean,
			default: false,
			required: false
		},
		inlineIcon: {
			type: String,
			default: "",
			required: false
		},
		label: {
			type: String,
			required: true
		},
		hint: {
			type: String,
			default: "",
			required: false
		},
		icon: {
			type: String,
			default: "",
			required: false
		},
		readonly: {
			type: Boolean,
			default: false,
			required: false
		},
		trim: {
			type: Boolean,
			default: true,
			required: false
		},
		type: {
			type: String,
			default: "text",
			required: false
		},
		value: {
			type: String,
			default: "",
			required: false
		}
	},
	data () {
		return {
			flashHintText: ""
		};
	},
	beforeDestroy() {
		clearTimeout(this.flashHintTimeout);
	},
	methods: {
		flashHint(hintText) {
			if (hintText.length === 0)
				return;

			this.flashHintText = hintText;

			clearTimeout(this.flashHintTimeout);

			this.flashHintTimeout = setTimeout(() => {
				this.flashHintText = "";
			}, 2000);
		}
	}
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>

<style lang="scss">
.ui-icon--inline {
	.md-button {
		margin-right: 0;
	}
}
.md-helper-text {
	left: 0;
}
// IE11 / Edge legacy fix to not display native clear or password show/hide toggle symbols
.md-input::-ms-clear,
.md-input::-ms-reveal {
	display: none;
}
</style>
